import Lifecycle from "./Lifecycle";
export default function Onboarding() {
  return <Lifecycle initialTab="onboarding" />;
}
